import { Box, SxProps, Theme } from "@mui/material";
import ButtonComponent from "components/button/ButtonComponent";
import SearchBox from "components/SearchBox";
import { MstItemDetailTireSelectRequest } from "../types/tire";

interface TireListSearchProps {
  sxBox?: SxProps<Theme>;
  params: MstItemDetailTireSelectRequest;
  setParams: (params: MstItemDetailTireSelectRequest) => void;
  onSearch: () => void;
}

/**
 * The TireListSearch component.
 * @param {object} props - The component props.
 */
export default function TireListSearch({
  sxBox,
  params,
  setParams,
  onSearch,
}: TireListSearchProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "40px",
        ...sxBox,
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: "15px",
          flexDirection: { xs: "column", lg: "row" },
          flexWrap: { xs: "nowrap", md: "wrap" },
          justifyContent: { xs: "center", md: "flex-start" },
        }}
      >
        <SearchBox
          sx={{ minWidth: 0 }}
          sxLabel={{ width: "156px", minWidth: "156px", boxSizing: "border-box" }}
          sxTextField={{ width: "190px" }}
          title="YH商品コード"
          id="yh-store"
          placeholder=""
          value={params.item_cd}
          onChangeText={(value) => {
            setParams({ ...params, item_cd: value });
          }}
        />
        <SearchBox
          sx={{ minWidth: 0 }}
          sxLabel={{ width: "156px", minWidth: "156px", boxSizing: "border-box" }}
          sxTextField={{ width: "190px" }}
          title="メーカー名"
          id="maker_name"
          placeholder=""
          value={params.maker_name}
          onChangeText={(value) => {
            setParams({ ...params, maker_name: value });
          }}
        />
        <SearchBox
          sx={{ minWidth: 0 }}
          sxLabel={{ width: "156px", minWidth: "156px", boxSizing: "border-box" }}
          sxTextField={{ width: "190px" }}
          title="ブランド名"
          id="brand_name"
          placeholder=""
          value={params.brand_name}
          onChangeText={(value) => {
            setParams({ ...params, brand_name: value });
          }}
        />
        <SearchBox
          sx={{ minWidth: 0 }}
          sxLabel={{ width: "156px", minWidth: "156px", boxSizing: "border-box" }}
          sxTextField={{ width: "190px" }}
          title="タイヤサイズ"
          id="tire-size"
          placeholder=""
          value={params.tire_size}
          onChangeText={(value) => {
            setParams({ ...params, tire_size: value });
          }}
        />
      </Box>
      <ButtonComponent
        theme="dark"
        sx={{
          width: "184px",
          fontSize: "25px",
        }}
        label="検索"
        onClick={() => onSearch()}
      />
    </Box>
  );
}
